import { defineMessages } from 'react-intl';
export default defineMessages({
  contentTabLabel: {
    id: "General.contentLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Content"
    }]
  },
  hideLabel: {
    id: "General.hideLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Hide"
    }]
  },
  readMoreLabel: {
    id: "General.readMoreLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Read more"
    }]
  },
  continueToBtnLabel: {
    id: "CourseDetailsHeader.continueToBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Continue to "
    }, {
      "type": 1,
      "value": "lessonName"
    }]
  },
  startBtnLabel: {
    id: "CourseDetailsHeader.startBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Start course"
    }]
  },
  giveCourseFedbackLabel: {
    id: "CourseDetailsHeader.giveCourseFedbackLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Give feedback regarding this course"
    }]
  },
  discussionTabLabel: {
    id: "CourseDetailsHeader.discussionTabLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Discussions"
    }]
  },
  discussionTabLabelWithCount: {
    id: "CourseDetailsHeader.discussionTabLabelWithCount",
    defaultMessage: [{
      "type": 0,
      "value": "Discussions ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": ")"
    }]
  },
  notesTabLabel: {
    id: "CourseDetailsHeader.notesTabLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Notes"
    }]
  },
  notesTabLabelWithCount: {
    id: "CourseDetailsHeader.notesTabLabelWithCount",
    defaultMessage: [{
      "type": 0,
      "value": "Notes ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": ")"
    }]
  },
  recommendedStudyTime: {
    id: "CourseDetailsHeader.recommendedStudyTime",
    defaultMessage: [{
      "type": 0,
      "value": "Recommended study time:"
    }]
  },
  mediaDurations: {
    id: "CourseDetailsHeader.mediaDurations",
    defaultMessage: [{
      "type": 0,
      "value": "Media durations:"
    }]
  },
  studyTimeHours: {
    id: "CourseDetailsHeader.studyTimeHours",
    defaultMessage: [{
      "type": 1,
      "value": "time"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 6,
      "value": "time",
      "options": {
        "one": {
          "value": [{
            "type": 0,
            "value": "hour"
          }]
        },
        "other": {
          "value": [{
            "type": 0,
            "value": "hours"
          }]
        }
      },
      "offset": 0,
      "pluralType": "cardinal"
    }]
  },
  studyTimeMinutes: {
    id: "CourseDetailsHeader.studyTimeMinutes",
    defaultMessage: [{
      "type": 1,
      "value": "time"
    }, {
      "type": 0,
      "value": " minutes"
    }]
  },
  autoHideDate: {
    id: "CourseDetailsHeader.autoHideDate",
    defaultMessage: [{
      "type": 0,
      "value": "The removal date: "
    }, {
      "type": 1,
      "value": "date"
    }]
  },
  addToBtnLabel: {
    id: "CourseDetailsHeader.addToFavoritesBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Add to favourites"
    }]
  },
  removeFromBtnLabel: {
    id: "CourseDetailsHeader.removeFromFavoritesBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Remove from favourites"
    }]
  },
  shareBtnLabel: {
    id: "CourseDetailsHeader.shareBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Copy course link"
    }]
  },
  editCourseBtnLabel: {
    id: "CourseDetailsContent.editCourseBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Edit"
    }]
  },
  removeLabel: {
    id: "CourseDetailsContent.removeLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Remove"
    }]
  },
  submitDeleteItemMsg: {
    id: "CourseDetailsContent.submitDeleteItemMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Are you sure you want to delete "
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "?"
    }]
  },
  itemWillBeRemovedMsg: {
    id: "CourseDetailsContent.itemWillBeRemovedMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Course "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 1,
        "value": "name"
      }]
    }, {
      "type": 0,
      "value": " will be removed."
    }]
  },
  itemRemoved: {
    id: "CourseDetailsContent.itemRemoved",
    defaultMessage: [{
      "type": 0,
      "value": "Course "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 1,
        "value": "name"
      }]
    }, {
      "type": 0,
      "value": " has been removed"
    }]
  },
  addForOffline: {
    id: "CourseDetailsHeader.addForOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Download for offline"
    }]
  },
  removeForOffline: {
    id: "CourseDetailsHeader.removeForOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Remove from offline"
    }]
  },
  courseIsDownloading: {
    id: "CourseItem.courseIsDownloading",
    defaultMessage: [{
      "type": 0,
      "value": "Downloading course \""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\", related lessons and notes..."
    }]
  },
  courseIsDownloaded: {
    id: "CourseItem.courseIsDownloaded",
    defaultMessage: [{
      "type": 0,
      "value": "\""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\" offline access download complete"
    }]
  },
  courseIsRemovedFromOffline: {
    id: "CourseItem.courseIsRemovedFromOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Course \""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\", related lessons and notes are removed from offline access"
    }]
  },
  browserDoesNotSupportCaching: {
    id: "CourseItem.browserDoesNotSupportCaching",
    defaultMessage: [{
      "type": 0,
      "value": "Your browser does not support offline caching. For better browsing experience, we recommend using Skhole with Google Chrome"
    }]
  },
  errorDuringCourseDownloading: {
    id: "CourseItem.errorDuringCourseDownloading",
    defaultMessage: [{
      "type": 0,
      "value": "Oops, error happened during updating cache: "
    }, {
      "type": 1,
      "value": "error"
    }]
  },
  courseIsDownloadingWarning: {
    id: "CourseItem.courseIsDownloadingWarning",
    defaultMessage: [{
      "type": 0,
      "value": "Course \""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\" is still downloading for offline, are you sure you want to exit?"
    }]
  },
  availableForOfflineTime: {
    id: "CourseItem.availableForOfflineTime",
    defaultMessage: [{
      "type": 1,
      "value": "days"
    }, {
      "type": 0,
      "value": " days remaining in offline mode"
    }]
  },
  showCertificateBtnLabel: {
    id: "CourseDetailsHeader.showCertificateBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Show certificate"
    }]
  },
  resetCourseProgress: {
    id: "CourseDetailsHeader.resetCourseProgress",
    defaultMessage: [{
      "type": 0,
      "value": "Restart course"
    }]
  },
  resetCourseTitle: {
    id: "CourseDetailsHeader.resetCourseTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Do you want to reset course progress status?"
    }]
  },
  courseProgressResetSnackbar: {
    id: "CourseDetailsHeader.courseProgressResetSnackbar",
    defaultMessage: [{
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": " progress has been reset"
    }]
  },
  courseProgressResetDescription: {
    id: "CourseDetailsHeader.courseProgressResetDescription",
    defaultMessage: [{
      "type": 8,
      "value": "div",
      "children": [{
        "type": 8,
        "value": "p",
        "children": [{
          "type": 0,
          "value": "Choosing yes will reset completion status of lessons in course. You cannot undo it. If you just want to see lessons again choose No."
        }]
      }, {
        "type": 8,
        "value": "p",
        "children": [{
          "type": 0,
          "value": "Note, resetting course status will not affect old statistics and old certificates. You may want to reset course status if your "
        }, {
          "type": 1,
          "value": "teacher"
        }, {
          "type": 0,
          "value": " wants you to re-study the course."
        }]
      }]
    }]
  },
  teacher: {
    id: "General.teacher",
    defaultMessage: [{
      "type": 0,
      "value": "teacher"
    }]
  },
  teacherProfessional: {
    id: "General.teacherProfessional",
    defaultMessage: [{
      "type": 0,
      "value": "teacher"
    }]
  },
  deleteBtn: {
    id: "CourseDetailsHeader.deleteBtn",
    defaultMessage: [{
      "type": 0,
      "value": "Remove course"
    }]
  },
  copyBtn: {
    id: "CourseDetailsHeader.copyBtn",
    defaultMessage: [{
      "type": 0,
      "value": "Copy course"
    }]
  },
  copyConfirmationTitle: {
    id: "CourseDetailsHeader.copyConfirmationTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Are you sure to copy this course?"
    }]
  },
  copyConfirmationSubmitLabel: {
    id: "CourseDetailsHeader.copyConfirmationSubmitLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Copy"
    }]
  },
  editCourse: {
    id: "CourseDetailsHeader.editCourse",
    defaultMessage: [{
      "type": 0,
      "value": "Edit course"
    }]
  },
  pwaIsAboutToBeDisabled: {
    id: "General.pwaIsAboutToBeDisabled",
    defaultMessage: [{
      "type": 0,
      "value": "Removing this course from offline cache temporarily disables offline mode. All pages will reload"
    }]
  },
  confirm: {
    id: "General.confirmDisablePwa",
    defaultMessage: [{
      "type": 0,
      "value": "Confirm"
    }]
  },
  dismiss: {
    id: "General.dismissDisablePwa",
    defaultMessage: [{
      "type": 0,
      "value": "Dismiss"
    }]
  },
  serviceNamePossessive: {
    id: "General.defaultServiceNamePossessive",
    defaultMessage: [{
      "type": 0,
      "value": "Skhole's"
    }]
  },
  viewLivestreamChat: {
    id: "CourseDetailsHeader.viewLivestreamChat",
    defaultMessage: [{
      "type": 0,
      "value": "View Stream Chat"
    }]
  },
  hideLivestreamChat: {
    id: "CourseDetailsHeader.hideLivestreamChat",
    defaultMessage: [{
      "type": 0,
      "value": "Hide Stream Chat"
    }]
  },
  streaming: {
    id: "CourseDetailsHeader.streaming",
    defaultMessage: [{
      "type": 0,
      "value": "Livestream"
    }]
  },
  streamingStartAt: {
    id: "CourseDetailsHeader.streamingStartAt",
    defaultMessage: [{
      "type": 1,
      "value": "start"
    }, {
      "type": 0,
      "value": " - "
    }, {
      "type": 1,
      "value": "end"
    }]
  },
  progressBarLabel: {
    id: "CourseDetailsHeader.progressBarLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Progress"
    }]
  },
  forceCourseRestartForTaskNotice: {
    id: "CourseDetailsHeader.forceCourseRestartForTaskNotice",
    defaultMessage: [{
      "type": 0,
      "value": "You have been assigned a task that requires restarting the course, since you completed current course more than "
    }, {
      "type": 1,
      "value": "months"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 6,
      "value": "months",
      "options": {
        "one": {
          "value": [{
            "type": 0,
            "value": "month"
          }]
        },
        "other": {
          "value": [{
            "type": 0,
            "value": "months"
          }]
        }
      },
      "offset": 0,
      "pluralType": "cardinal"
    }, {
      "type": 0,
      "value": " ago. Please restart the course to start the task."
    }]
  },
  mediaDurationsTooltip: {
    id: "CourseDetailsHeader.mediaDurationsTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "The total duration of the course content. Based on the time required to go through the materials without assignments or in-depth work."
    }]
  },
  recommendedStudyTimeTooltip: {
    id: "CourseDetailsHeader.recommendedStudyTimeTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Estimated total time required. Includes reviewing the materials, completing assignments, internalizing the material, and reviewing."
    }]
  },
  manageTabLabel: {
    id: "CourseDetailsHeader.manageTabLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Manage tab"
    }]
  }
});